import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

// import Pagination from '../../components/pagination';
import {
  fetchLoginHistory,
} from '../../actions';

const dateFormat = 'L LT';

class LoginHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
    this.setCurrentPage = this.setCurrentPage.bind(this);
    this.updateData = this.updateData.bind(this);
  }

  componentDidMount() {
    this.updateData();
  }

  setCurrentPage(number) {
    const { currentPage } = this.state;
    if (currentPage !== number) {
      this.setState({
        currentPage: number,
      });
      this.updateData(number);
    }
  }

  updateData(page) {
    const { dispatch } = this.props;
    const params = {
      limit: 10,
      page: 1,
    };
    if (page) {
      params.page = page;
    }
    dispatch(fetchLoginHistory(params));
  }

  render() {
    const { loginPagination, loginHistory, user } = this.props;
    const { currentPage } = this.state;

    const loginLoop = loginHistory && loginHistory.length && loginHistory.map((item, index) => {
      let timestamp;
      if (item && item.ts) {
        timestamp = moment.unix(item.ts).format(dateFormat)
      }
      const key = `ip-${index}`;
      return (
        <tr key={key}>
          <td>{item.ip}</td>
          <td>{timestamp}</td>
        </tr>
      );
    });

    return (
      <div className="grid-x">
        <div className="cell small-12 medium-12 large-12" style={{marginBottom: 20}}>
          <a className="backlink" href="/settings">
            <FontAwesomeIcon
              size="sm"
              icon={faChevronLeft}
            />
            &nbsp;
            Back to Settings
          </a>
        </div>
        <div className="cell panel v2 small-12 medium-12 large-12">
          <div className="panel-label">
            Login History
          </div>
          <div className="cell small-12 medium-12 large-12">
            {loginHistory && loginHistory.length ? (
              <div>
                <table className="login-table">
                  <thead>
                    <tr>
                      <th>IP</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loginLoop}
                  </tbody>
                </table>
                {/* <Pagination
                  rowsPerPage={loginPagination.limit || 10}
                  // totalRows={loginPagination.count || 0}
                  totalRows={10}
                  setCurrentPage={this.setCurrentPage}
                  currentPage={currentPage}
                /> */}
              </div>
            ) : (
              <div>
                <table>
                  <thead>
                    <tr>
                      <th>IP</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                </table>
                <h3 className="no-data">No Login History</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  loginHistory: state.user.loginHistory,
  loginPagination: state.user.loginPagination,
});

export default connect(mapStateToProps)(LoginHistory);
